import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Radio = ({settings = {}}) => {
    return (
        <InputWrapper className="radio">
            <span className="checkmark"></span>
            <div className="description">
                <span className={classNames({"required": settings.required})}>{settings.title}</span>
                {settings.description && <p>{settings.description}</p>}
            </div>
        </InputWrapper>
    )
};

export default Radio;